import { useState } from 'react';

export function useWakeLock() {
  const [isEnable, setIsEnable] = useState(false);
  const [wakeLock, setWakeLock] = useState(null);

  // Function to request the screen Wake Lock
  const request = async () => {
    try {
      const wakeLock = await navigator.wakeLock.request('screen');
      setWakeLock(wakeLock);
      setIsEnable(true);

      wakeLock.addEventListener('release', () => {
        console.log('Wake Lock has been released');
      });
    } catch (err) {
      console.error('Failed to request screen Wake Lock:', `${err.name}, ${err.message}`);
      setIsEnable(false);
    }
  };

  // Function to release the screen Wake Lock
  const release = () => {
    if (wakeLock) {
      wakeLock.release();
      setWakeLock(null);
      setIsEnable(false);
    }
  };

  return {
    isEnable,
    request,
    release,
  };
}
